<!-- Copyright 2025, Common Good Learning Tools LLC -->
<template>
	<tr class="k-table-row" @click="show">
		<td v-for="(header, i) in headers" :class="[{'title-column': !i}, {'center-text': header.align == 'center'}]">
			<v-icon v-if="header.value == 'button'" class="button" small>fas fa-arrow-up-right-from-square</v-icon>

			<v-btn v-else-if="header.value == 'pay'" color="primary" depressed  x-small @click="pay">Paid</v-btn>

			<div v-else-if="header.value == 'action'" class="d-flex">
				<span class="mr-1">{{ get_status_text(row.from) }}</span>
				<v-icon class="mr-1" small>fas fa-arrow-right</v-icon>
				<span>{{ get_status_text(row.to) }}</span>
			</div>

			<div v-else-if="header.value == 'alignments'"class="k-resource-collection-item-standards-wrapper" @click.stop="">
				<v-spacer/>
				<div v-if="row.standards.length > 1" style="margin-right:2px;">
					<v-btn
						v-if="show_all_standards"
						style="font-size:12px; min-width:20px;"
						class="px-0"
						color="#333"
						x-small
						text
						@click="show_all_standards = false"
					>
						<v-icon style="font-size:10px" x-small>fas fa-chevrons-right</v-icon>
					</v-btn>
					
					<v-btn v-if="!show_all_standards" color="#333" class="px-0" x-small text @click="show_all_standards = true" style="font-size:12px">
						+{{ row.standards.length - 1 }}
						<v-icon style="margin-left:3px; font-size:10px;">fas fa-chevrons-left</v-icon>
					</v-btn>
				</div>

				<CASEItemBtn
					v-for="(s, i) in row.standards"
					v-show="i < 1 || show_all_standards"
					:item="s"
					:key="s.identifier"
					:outer_class="'ml-1'"
					:selected_items="row.standards"
					:framework_identifier="s.framework_identifier"
					satchel_determines_framework_id="yes"
					star_primary_alignments="false"
					x-small
				/>
				<v-spacer/>
			</div>

			<span v-else v-html="display_value(row, header.value)"></span>
		</td>
	</tr>
</template>

<script>
import { mapState } from 'vuex'
import processes from './processes'
import CASEItemBtn from '../standards/CASEItemBtn'

export default {
	name: 'AssetManagerTableRow',

	components: {CASEItemBtn},

	props: {
		row: {type: Object, required: true},
		headers: {type: Array, required: true},
		type: {type: String, required: true}
	},

	data() {
		return {
			show_all_standards: false,
		}
	},

	computed: {
		...mapState(['site_config', 'user_info']),

		statuses() {
			let arr = processes[this.site_config.asset_manager_process].general.statuses

			arr.unshift({key: '', text: 'Not Submitted'})

			return arr
		}
	},

	methods: {
		show() {
			if(this.type == 'asset') this.$emit('showStatus')
		},

		display_value(item, key) {
			let value = item[key]
			if ((key.includes('date') || key.includes('_at')) && value) {
				let date = new Date(value)
				if (date != 'Invalid Date'){
					return date.toLocaleDateString()
				} else {
					return value
				}
			} else if (key == 'subjects') {
				value = value.map(x => x.text).join(', ')
			} else if (key == 'grades') {
				value = value.join(', ')
			} else if (value?.hasOwnProperty('text')) {
				value = value.text
			}

			return value
		},

		get_status_text(status) {
			if (!status) status = ''
			let item = this.statuses.filter(x => x.key == status)[0]
			return item.text ?? ''
		},

		pay() {
			let entry = object_copy(this.row)
			entry.paid = 1
			entry.paid_date = new Date().toJSON().slice(0, 19).replace('T', ' ')
			entry.user_id = this.user_info.user_id	
			this.$emit('pay', entry)
		}
	}
}
</script>

<style lang="scss" scoped>
.k-table-row {
	.button {
		cursor: pointer;
	}

	.title-column {
		max-width: 200px;
	}

	.center-text {
		text-align: center;
	}
}
</style>